export default __webpack_public_path__ + "static/media/Ji Pang-Ee.427a015d.jpg";